import { useId, useState } from "react";
import { InfoOutlined } from "@mui/icons-material";

// Hover (mouse) shows the note beside the icon. Tap or click pins it open, for touch screens.
const FeatureInfo = ({ text }) => {
   const [hovered, setHovered] = useState(false);
   const [pinned, setPinned] = useState(false);
   const id = useId();
   const open = hovered || pinned;

   return (
      <span
         style={{ position: "relative", display: "inline-flex", verticalAlign: "middle", marginLeft: "4px" }}
         onPointerEnter={(event) => { if (event.pointerType === "mouse") setHovered(true); }}
         onPointerLeave={(event) => { if (event.pointerType === "mouse") setHovered(false); }}
         onKeyDown={(event) => { if (event.key === "Escape") { setHovered(false); setPinned(false); } }}
      >
         <button
            type="button"
            aria-describedby={open ? id : undefined}
            aria-label="More about this feature"
            onClick={() => setPinned((value) => !value)}
            style={{
               display: "inline-flex", padding: 0, border: "none", background: "none", cursor: "pointer",
               color: "#0046ff", WebkitTextFillColor: "currentColor",
            }}
         >
            <InfoOutlined sx={{ fontSize: 16 }} />
         </button>
         {open && (
            <span
               id={id}
               role="tooltip"
               style={{
                  position: "absolute", bottom: "calc(100% + 8px)", left: "-6px", zIndex: 20,
                  width: "max-content", maxWidth: "240px", padding: "8px 10px", borderRadius: "8px",
                  background: "#ffffff", border: "1px solid #e4e7ec", boxShadow: "0 8px 24px rgba(16, 24, 40, 0.12)",
                  fontSize: "0.8125rem", fontWeight: 400, lineHeight: 1.4, textAlign: "left", whiteSpace: "normal",
                  color: "#374151", WebkitTextFillColor: "#374151",
               }}
            >
               {text}
            </span>
         )}
      </span>
   );
};

export default FeatureInfo;
